import type { TenantConfig } from '@/types/TenantConfig'

export const omsi: TenantConfig = {
  logo: 'assets/omsi/static/logo.svg',
  teaserImageSize: {
    width: 350,
    height: 225,
  },
  preventAlonePurchase: 'Youth',
  themeOptions: {
    datePicker: {
      selectedDayTextColor: '#000000',
    },
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/omsi/static/completed2.jpg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-190px',
      },
      showTicketsLink: true,
    },
    eventListingWithFilters: {
      dateFilters: true,
    },
    eventDetailRoute: {
      showVenue: true,
    },
    eventListingItem: {
      showVenue: true,
    },
    reserveDateFirst: {
      setInitialDate: true,
    },
    cartWidget: {
      showItemImage: true,
    },
  },
  i18nOverrides: {
    en: {
      conflictTimes: 'There are additional times available but they conflict with experiences already in your order:',

      selectPaymentMethod: {
        title: 'Payment Details',
      },

      cartExpire: {
        title: 'This session has timed out to help keep your information secure.',
        buttonLabel: 'Return to Ticketing',
      },

      accountLinks: {
        loginLinkShortLabel: 'Member Login',
        loginLinkLongLabel: 'Member Login',
      },

      categoryFilters: {
        all: 'All Experiences',
      },

      payButton: {
        desktop: {
          proceedButtonLabel: 'Purchase',
          completeButtonLabel: 'Purchase',
        },
        mobile: {
          proceedButtonLabel: 'Purchase',
          completeButtonLabel: 'Purchase',
        },
      },

      applyGiftCards: {
        applyGiftCard: 'Apply a gift card or redeem membership',
        applyAnotherGiftCard: 'Apply another gift card',
      },

      applyGiftCardsModal: {
        giftCardNumberLabel: 'Gift card or gift membership number',
      },

      membership: {
        title: 'Become a Member',
      },

      membershipFormLabels: {
        member: {
          default: 'How would you like your name to appear on your digital membership card?',
        },
        second_card: {
          default: 'Would you like the name of the second adult to appear on your digital membership card?',
        },
      },

      namedMembers: {
        roleTitles: {
          member: 'How would you like your name to appear on your digital membership card?',
        },
        giftTitles: {
          member: "Recipient's name (as it should appear on the membership card).",
        },
        singleOptionalLabel: 'Would you like the name of the second adult to appear on your digital membership card?',
      },
    },
  },
}
